import { createFileRoute } from '@tanstack/react-router';
import { GeneralLedgerExportPage } from '@/features/accounting/fec/components/GeneralLedgerExportPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/fec/')({
  component: GeneralLedgerExportPage,
});
